import {
  Button,
  Flex,
  Grid,
  Input,
  Label,
  Text,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

import useErrors from "hooks/useErrors";
import LabelRequired from "components/utils/LabelRequired";

const HolidayForm = ({ onSubmit, type = "create", initialValues }) => {
  const [holidayForm, setHolidayForm] = useState(initialValues);
  const [errors, setErrors] = useState({
    name: "",
    date: "",
  });
  const validateErrors = useErrors({
    date: "isRequired",
  });

  const onSubmitForm = () => {
    let hasErrors = false;

    Object.entries(holidayForm).forEach((itemForm) => {
      const [name, value] = itemForm;
      const check = !!checkErrors(name, value);
      if (!hasErrors) hasErrors = check;
    });

    if (!hasErrors) onSubmit(holidayForm);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setHolidayForm((prevSt) => ({
      ...prevSt,
      [name]: value,
    }));
    checkErrors(name, value);
  };

  const checkErrors = (name, value) => {
    const errorMessage = validateErrors(name, value);
    if (errorMessage)
      setErrors((prevErr) => ({ ...prevErr, [name]: errorMessage }));
    else setErrors((prevErr) => ({ ...prevErr, [name]: "" }));
    return errorMessage;
  };

  const resetFormValues = () => {
    setErrors({
      name: "",
      date: "",
    });
    setHolidayForm(initialValues);
  };

  useEffect(() => {
    setHolidayForm(initialValues);
  }, [initialValues]);

  return (
    <>
      <Grid rowGap="15px" columnGap="15px" padding="20px">
        <Grid
          columnGap="15px"
          templateColumns={{ base: "1fr", large: "2fr 2fr" }}
        >
          <Flex direction="column" gap="8px">
            <Label htmlFor="date">
              <LabelRequired text={strings.fields.date.label} />
            </Label>
            <Input
              name="date"
              label={strings.fields.date.label}
              value={holidayForm.date || ""}
              type="date"
              onChange={onChange}
              hasError={!!errors.date}
            ></Input>
            {errors.date && (
              <Text fontSize="14px" variation="error">
                {errors.date}
              </Text>
            )}
          </Flex>
          <TextField
            name="name"
            label={strings.fields.name.label}
            value={holidayForm.name}
            onChange={onChange}
            errorMessage={errors.name}
            hasError={!!errors.name}
          ></TextField>
        </Grid>
        <Flex justifyContent="end">
          <Button
            children={strings.fields.buttons.reset}
            onClick={resetFormValues}
          ></Button>
          <Button
            children={
              type === "create"
                ? strings.fields.buttons.create
                : strings.fields.buttons.save
            }
            onClick={onSubmitForm}
            variation="primary"
            isDisabled={Object.values(errors).some((e) => !!e)}
          ></Button>
        </Flex>
      </Grid>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      name: {
        label: "Nombre",
      },
      date: {
        label: "Fecha",
      },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
      },
    },
  },
});

export default HolidayForm;
